import React, { useState } from "react";
import styles from "./EditInspirationalGallery.module.css";
import AddImage from "../../../assets/RoomImage.png";
import {
  DropDown,
  InputField,
  SubmitButton,
  TextComponent,
} from "../../../components";
import { Col, Row, Switch } from "antd";
import { useLocation, useNavigate } from "react-router-dom";

const EditInspirationalGallery = () => {
  const [category, setCategory] = useState("");
  const [vendor, setVendor] = useState("");
  const [checked, setchecked] = useState("");
  const navigate = useNavigate();
const state = useLocation();
console.log('staeeee', state);
  const handleChangeCategory = (value) => {
    setCategory(value);
  };
  const handleChangeVendor = (value) => {
    setVendor(value);
  };
  const onChange = (checked) => {
    setchecked(checked);
  };
  return (
    <div className={styles.mainCon}>
      <Row className={styles.subMainCon}>
        {/* <Col className={styles.subLeft}> */}
        <Col className={styles.subLeft}>
          <DropDown
            label={"Category"}
            placeholder={"Flowers"}
            stylesClass={styles.dropdown}
            name={"category"}
            onChange={handleChangeCategory}
            options={[
              { value: "Flowers", option: "Flowers" },
              { value: "Events", option: "Events" },
              { value: "Foods", option: "Foodstor" },
            ]}
          />
          <InputField styles={styles.input} label="Name" placeholder={"Rose"} />
          <div className={styles.toggleDiv}>
            <TextComponent
              text={"Allow Everyone To View"}
              textClass={styles.toggleTxt}
            />
            <Switch
              defaultChecked={false}
              onChange={onChange}
              size={"default"}
              style={{ backgroundColor: checked && "var(--primary-color)" }}
            />
          </div>
          {!checked && (
            <DropDown
              label={"Assign to vendor"}
              placeholder={"Trish James"}
              stylesClass={styles.dropdown}
              name={"category"}
              onChange={handleChangeVendor}
              options={[
                { value: "Flowers", option: "James" },
                { value: "Events", option: "Henry" },
              ]}
            />
          )}
        </Col>
        <Col className={styles.subRight}>
          <img src={AddImage} />
        </Col>
      </Row>
      <div className={styles.btnDiv}>
        <SubmitButton
          title={"Save"}
          btnClass={styles.btn}
          onClick={() => navigate(-1)}
        />
      </div>
    </div>
  );
};

export default EditInspirationalGallery;
